<template>
    <div>
        <progress-bar
            type="large"
            :progress="currentProgress"
            :limit="maxThreshold"
            :steps="steps"
            :bar-tooltip="barTooltip"
        />
        <div class="text-center text-sm mt-2">
            <strong>{{ progressDisplay }}</strong>
        </div>
    </div>

</template>

<script>
import ProgressBar from '@/components/global/ui/ProgressBar'
export default {
    components: {
        ProgressBar
    },
    name: 'RetrSalesGoalsProgressBar',
    props: {
        thresholds: {
            type: Array,
            required: true
        },
        currentProgress: {
            type: Number,
            required: true
        }
    },
    computed: {
        /**
         * Sorted thresholds array (cached)
         * Single source of truth for sorted data
         */
        sortedThresholds() {
            if (!this.thresholds?.length) return []
            return [...this.thresholds].sort((a, b) => a - b)
        },

        maxThreshold() {
            if (!this.sortedThresholds.length) return 0
            return this.sortedThresholds[this.sortedThresholds.length - 1]
        },

        steps() {
            return this.sortedThresholds.map((threshold, index) => ({
                value: threshold,
                label: index + 1
            }))
        },

        nextThreshold() {
            // Find the next threshold greater than current progress
            return this.sortedThresholds.find(
                threshold => threshold > this.currentProgress
            ) || null
        },

        remainingToNextThreshold() {
            // Calculate how much is needed to reach the next threshold
            if (!this.nextThreshold) return 0
            return this.nextThreshold - this.currentProgress
        },

        barTooltip() {
            if (!this.nextThreshold) {
                return undefined
            }
            return `Do osiągnięcia następnego progu potrzeba ${this.remainingToNextThreshold.toLocaleString(
                'pl-PL'
            )} zł`
        },

        progressDisplay() {
            return `${this.$options.filters.currency(this.currentProgress)} / ${this.$options.filters.currency(this.maxThreshold)}`
        }
    }
}
</script>